
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".625","y":"1.125","width":"7.639","height":"7.639","rx":"3.125","stroke":"#339299","stroke-width":"1.25"}}),_c('rect',{attrs:{"x":".625","y":"12.236","width":"7.639","height":"7.639","rx":"3.125","stroke":"#339299","stroke-width":"1.25"}}),_c('rect',{attrs:{"x":"11.736","y":"1.125","width":"7.639","height":"7.639","rx":"3.125","fill":"#339299","stroke":"#339299","stroke-width":"1.25"}}),_c('rect',{attrs:{"x":"11.736","y":"12.236","width":"7.639","height":"7.639","rx":"3.125","stroke":"#339299","stroke-width":"1.25"}})])
          )
        }
      }
    